import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SvgIcon } from "@cinch-labs/design-system";
import styles from "./store-details-list.module.css";
export const StoreDetailsList = ({ icon , title , children  })=>/*#__PURE__*/ _jsxs("section", {
        className: styles.storeDetailsSection,
        children: [
            /*#__PURE__*/ _jsx(SvgIcon, {
                name: icon,
                size: 20,
                className: styles.svg
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.storeDetails,
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        className: styles.storeDetailsTitle,
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.storeDetailsContent,
                        children: children
                    })
                ]
            })
        ]
    });
